import React, { useCallback, useContext, useEffect, useState } from 'react';
import ReactFlow, {
    addEdge,
    MiniMap,
    Controls,
    Background,
    useNodesState,
    useEdgesState,
    ReactFlowProvider,
    useStore,
} from 'reactflow';

import 'reactflow/dist/style.css';
import './custom-nodes/overview.css';
import Loader from '../loaders/Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faDownload, faFileEdit, faListNumeric, faMinus, faObjectGroup, faPlus, faSignOutAlt, faTrash, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import { toast } from 'react-toastify';
import instance from '../../api/client';
import authService from '../../authentication';
import AltImpact from './custom-nodes/AltImpact';
import AppContext from '../../contexts/AppContext';
import DiagramHeader from './custom-nodes/DiagramHeader';
import Table from '../Table';
import { useNavigate, useNavigation } from 'react-router-dom';
import TakeSnapshot from '../TakeSnapshot';

const nodeTypes = {
    staticImpact: AltImpact,
    diagramHeader: DiagramHeader
};

const minimapStyle = {
    height: 120,
};

const onInit = (reactFlowInstance) => console.log('flow loaded:', reactFlowInstance);

const cloneObject = (object) => {
    let newObj = JSON.stringify(object)
    newObj = JSON.parse(newObj)
    return newObj
}

const PrioritizationUI = ({ initialNodes, initialEdges, getImpacts, state }) => {
    const navigate = useNavigate();
    const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
    const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
    const [loading, setLoading] = useState(false);
    const [showCount, setShowCount] = useState(true);
    const [showGroup, setShowGroup] = useState(false);
    const [selectedGroupId, setSelectedGroupId] = useState('');
    const [selectedCountId, setSelectedCountId] = useState('');
    const [counts, setCounts] = useState([]);
    const [countIds, setCountIds] = useState([]);
    const [updatedCtName, setUpdatedCtName] = useState({})
    const [groups, setGroups] = useState([]);
    const [groupIds, setGroupIds] = useState([]);
    const [updatedGroupName, setUpdatedGroupName] = useState({})
    const { openInputModal, openModal, modalInputValue } = useContext(AppContext)
    const [sidebarOpen, setSideBarOpen] = useState(true);
    const [selected, setSelected] = useState([]);
    const [isDeleteMode, setIsDeleteMode] = useState(false);
    const [isAddMode, setIsAddMode] = useState(false);
    const [infoText, setInfoText] = useState('Hello, welcome friend');
    const [showHints, setShowHints] = useState(true)
    const [hintNumber, setHintNumber] = useState(0)
    const [isPrioritized, setIsPrioritized] = useState(false)
    const [showTable, setShowTable] = useState(false)
    const [tableData, setTableData] = useState({})
    const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), []);

    useEffect(() => {

        let cIds = new Set()
        let gIds = new Set()
        const staticImpacts = nodes.filter((node) => node.type == 'staticImpact')

        let isPrioritized_ = false
        staticImpacts.forEach((sI) => {
            isPrioritized_=true
            if (!sI.prioritizationModel?.individualRank) {
                isPrioritized_ = false
                return
            }
        })

        setIsPrioritized(isPrioritized_)

        staticImpacts.forEach((impact) => {
            if (impact?.prioritizationModel?.countId) {
                cIds.add(impact.prioritizationModel.countId)
            }
            if (impact?.prioritizationModel?.groupId) {
                gIds.add(impact.prioritizationModel.groupId)
            }
        })
        cIds = new Array(...cIds)
        let cs = cIds.map((cId) => staticImpacts.find((node) => node?.prioritizationModel?.countId == cId).countGroup)
        gIds = new Array(...gIds)
        let gs = gIds.map((gId) => staticImpacts.find((node) => node?.prioritizationModel?.groupId == gId).group)

        setCountIds(cIds)
        setGroupIds(gIds)
        setCounts(cs)
        setGroups(gs)

    }, [nodes])

    useEffect(() => {
        getTableView()
    }, [isPrioritized])

    const getTableView = async () => {
        try {
            const { data, status } = await instance.get(`/prioritize/table-view/${state.project.code}`, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            console.log("Prioritization Table Data:", data);
            setTableData(data)
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    const setUpdatedGroupName1 = (groupId, name) => {
        setUpdatedGroupName((prev) => {
            return {
                ...prev,
                [groupId]: name
            }
        })

    }
    const setUpdatedCtName1 = (countId, name) => {      
        setUpdatedCtName((prev) => {
            return {
                ...prev,
                [countId]: name
            }
        })
    }


    const selectedImpacts = selected.map((nid) => (
        nodes.find((node) => node?.id == nid)
    ))

    const selectedImpactIds = selectedImpacts?.map((node) => (
        node?._id
    ))

    const countImpacts = async (description) => {
        console.log(description);
        setLoading(true)
        try {
            const { data, status } = await instance.post(`/prioritize/count/create/${state.project.code}`, { impactIds: selectedImpactIds, countDescription: description }, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            if (status == 200) {
                console.log('Counted: ', data);
                setHintNumber(0);
                setSelected([]);
                const oldNodes = nodes.filter((n) => !selectedImpacts.includes(n))
                const counted = cloneObject(selectedImpacts).map((n) => {
                    const update = data.impacts.find((im) => im._id == n._id)
                    n = {
                        ...n,
                        countGroup: data.count_obj,
                        prioritizationModel: {
                            ...n.prioritizationModel,
                            countId: update.countId
                        }
                    }
                    return n
                })
                const newNodes = [...oldNodes, ...counted]

                setNodes(newNodes)
                onNodesChange(newNodes)
                toast.success(`Counted successfully`, {
                    position: toast.POSITION.TOP_CENTER, autoClose: 200
                });
            } else {
                toast.error(`Error: ${status}`, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)

    }

    const groupImpacts = async (name) => {
        setLoading(true)
        let notPrioritized = false
        selectedImpacts.forEach((impact) => {
            if (impact.prioritizationModel?.criteria_score == null) {
                notPrioritized = true
                return
            }
        })
        if (notPrioritized) {
            toast.info(`Cannot Group: Some selected impacts haven't been prioritized`, {
                position: toast.POSITION.TOP_CENTER
            });
            return
        }
        try {
            const { data, status } = await instance.post(`/prioritize/group/create`, { projectCode: state.project.code, impactIds: selectedImpactIds, groupName: name }, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            console.log('Grouped: ', data);
            if (status == 200) {
                const oldNodes = nodes.filter((n) => !selectedImpacts.includes(n))
                const grouped = cloneObject(selectedImpacts).map((n) => {
                    const update = data.impacts.find((im) => im._id == n._id)
                    n = {
                        ...n,
                        group: data.group,
                        prioritizationModel: {
                            ...n.prioritizationModel,
                            groupId: update.groupId
                        }
                    }
                    return n
                })
                setHintNumber(2)
                setSelected([])
                console.log(data);
                const newNodes = [...oldNodes, ...grouped]

                setNodes(newNodes)
                onNodesChange(newNodes)
                toast.success(`Grouped successfully`, {
                    position: toast.POSITION.TOP_CENTER, autoClose: 200
                });

                setLoading(false)
            } else {
                toast.error(`Error: ${status}`, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)

    }

    const addToCount = async () => {
        const impactsToAdd = selectedImpacts.filter((impact) => !impact.prioritizationModel?.countId)
        const impactIdsToAdd = impactsToAdd.map((node) => node._id)
        if (!impactsToAdd.length) {
            toast.info(`No new impacts to add`, {
                position: toast.POSITION.TOP_CENTER
            });
            return
        }
        setLoading(true)
        try {
            const { data, status } = await instance.post(`/prioritize/count/add`, { countId: selectedCountId, impactIds: impactIdsToAdd }, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            if (status == 200) {
                const oldNodes = nodes.filter((n) => !impactsToAdd.includes(n))
                const added = cloneObject(impactsToAdd).map((n) => {
                    const update = data.impacts.find((im) => im._id == n._id)
                    const countObj = counts[countIds.indexOf(selectedCountId)]
                    n = {
                        ...n,
                        countGroup: data.count_obj,
                        prioritizationModel: {
                            ...n.prioritizationModel,
                            countId: update.countId,
                        }
                    }
                    return n
                })
                const newNodes = [...oldNodes, ...added]

                setNodes(newNodes)
                onNodesChange(newNodes)
                toast.success(`Added successfully`, {
                    position: toast.POSITION.TOP_CENTER, autoClose: 200
                });

                setLoading(false)
            } else {
                toast.error(`Error: ${status}`, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)

    }

    const addToGroup = async () => {
        const impactsToAdd = selectedImpacts.filter((impact) => !impact.prioritizationModel?.groupId)
        const impactIdsToAdd = impactsToAdd.map((node) => node._id)
        if (!impactsToAdd.length) {
            toast.info(`No new impacts to add`, {
                position: toast.POSITION.TOP_CENTER
            });
            return
        }
        let notPrioritized = false
        impactsToAdd.forEach((impact) => {
            if (impact.prioritizationModel.criteria_score == null) {
                notPrioritized = true
                return
            }
        })
        if (notPrioritized) {
            toast.info(`Cannot Add to Group: Some selected impacts haven't been prioritized`, {
                position: toast.POSITION.TOP_CENTER
            });
            return
        }
        setLoading(true)
        try {
            const { data, status } = await instance.post(`/prioritize/group/add-items/${selectedGroupId}`, { impactIds: impactIdsToAdd }, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            if (status == 200) {
                const oldNodes = nodes.filter((n) => !impactsToAdd.includes(n))
                const added = cloneObject(impactsToAdd).map((n) => {
                    console.log('n:', n);
                    const update = data.impacts.find((im) => im._id == n._id)
                    n = {
                        ...n,
                        group: data.group,
                        prioritizationModel: {
                            ...n.prioritizationModel,
                            groupId: update.groupId
                        }
                    }
                    return n
                })
                const newNodes = [...oldNodes, ...added]

                setNodes(newNodes)
                onNodesChange(newNodes)
                toast.success(`Added successfully`, {
                    position: toast.POSITION.TOP_CENTER, autoClose: 200
                });

                setLoading(false)
            } else {
                toast.error(`Error: ${status}`, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)

    }

    const removeFromCount = async () => {
        const impactsToRemove = nodes.filter((impact) => (impact.prioritizationModel?.countId == selectedCountId) && !selectedImpactIds.includes(impact._id))
        console.log(impactsToRemove);

        if (!impactsToRemove.length) {
            toast.info(`No deselected impacts to remove`, {
                position: toast.POSITION.TOP_CENTER
            });
            return
        }
        setLoading(true)
        try {
            const { data, status } = await instance.post(`/prioritize/count/delete-items`, { countId: selectedCountId, impactIds: impactsToRemove.map((im) => im._id) }, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            if (status == 200) {
                const oldNodes = nodes.filter((n) => !impactsToRemove.includes(n))
                const removedFromCount = cloneObject(impactsToRemove).map((n) => {
                    n = {
                        ...n,
                        prioritizationModel: {
                            ...n.prioritizationModel,
                            countId: null
                        }
                    }
                    return n
                })
                const newNodes = [...oldNodes, ...removedFromCount]

                setNodes(newNodes)
                onNodesChange(newNodes)
                toast.success(`Removed successfully`, {
                    position: toast.POSITION.TOP_CENTER, autoClose: 200
                });

                setLoading(false)
            } else {
                toast.error(`Error: ${status}`, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)

    }

    const removeFromGroup = async () => {
        const impactsToRemove = nodes.filter((impact) => (impact.prioritizationModel?.groupId == selectedGroupId) && !selectedImpactIds.includes(impact._id))
        console.log(impactsToRemove);

        if (!impactsToRemove.length) {
            toast.info(`No deselected impacts to remove`, {
                position: toast.POSITION.TOP_CENTER
            });
            return
        }
        setLoading(true)
        try {
            const { data, status } = await instance.post(`/prioritize/group/delete-items/${selectedGroupId}`, { impactIds: impactsToRemove.map((im) => im._id) }, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            if (status == 200) {
                const oldNodes = nodes.filter((n) => !impactsToRemove.includes(n))
                const removedFromGroup = cloneObject(impactsToRemove).map((n) => {
                    n = {
                        ...n,
                        prioritizationModel: {
                            ...n.prioritizationModel,
                            groupId: null
                        }
                    }
                    return n
                })
                const newNodes = [...oldNodes, ...removedFromGroup]

                setNodes(newNodes)
                onNodesChange(newNodes)
                toast.success(`Removed successfully`, {
                    position: toast.POSITION.TOP_CENTER, autoClose: 200
                });

                setLoading(false)
            } else {
                toast.error(`Error: ${status}`, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)

    }

    const editCountName = async (name) => {
        setLoading(true)
        try{
            const {data, status} = await instance.put(`/prioritize/count/update-name/${selectedCountId}`, {name}, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            if(status == 200){
                toast.success(`Name updated successfully`, {
                    position: toast.POSITION.TOP_CENTER, autoClose: 200
                });
                console.log("updated ct name", selectedCountId)
                setUpdatedCtName1(selectedCountId, name)
                // getImpacts();
                 setLoading(false)
            }else{
                toast.error(`Error: ${status}`, {
                    position: toast.POSITION.TOP_CENTER, autoClose: 200
                });
            }
        }catch(error){
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER, autoClose: 200
            });
        }
        setLoading(false)
    }


    const editGroupName = async (name)=>{
        setLoading(true)
        try{
            const {data, status} = await instance.put(`/prioritize/group/update-name/${selectedGroupId}`, {name}, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            if(status == 200){
                toast.success(`Name updated successfully`, {
                    position: toast.POSITION.TOP_CENTER, autoClose: 200
                });
                
                setUpdatedGroupName1(selectedGroupId, name)
                setLoading(false)
                // getImpacts();
            }else{
                toast.error(`Error: ${status}`, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        }catch(error){
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)
    }

    const deleteCount = async () => {
        setLoading(true)
        try {
            const { data, status } = await instance.delete(`/prioritize/count/delete-group/${selectedCountId}`, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            if (status == 200) {

                toast.success(`Deleted successfully`, {
                    position: toast.POSITION.TOP_CENTER, autoClose: 200
                });

                getImpacts();

                setLoading(false)
            } else {
                toast.error(`Error: ${status}`, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)

    }

    const deleteGroup = async () => {
        setLoading(true)
        try {
            const { data, status } = await instance.delete(`/prioritize/group/delete-group/${selectedGroupId}`, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            if (status == 200) {

                toast.success(`Group Deleted successfully`, {
                    position: toast.POSITION.TOP_CENTER, autoClose: 200
                });

                getImpacts();

                setLoading(false)
            } else {
                toast.error(`Error: ${status}`, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)

    }

    const prioritize = async () => {
        setLoading(true)
        try {
            const { data, status } = await instance.post(`/prioritize/prioritize/${state.project.code}`, {}, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            console.log('Prioritization', data);
            let refreshedImpacts = data.impacts.map((impact) => {
                impact.id = `${impact.diagramId} ${impact.id}`
                return impact
            })
            console.log(refreshedImpacts);
            if (status == 200) {
                toast.success(`Prioritization successful`, {
                    position: toast.POSITION.TOP_CENTER
                });
                getImpacts();

                setLoading(false)
            } else {
                toast.error(`Error: ${status}`, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)

    }

    const getRelatedCountNodeIds = (id) => {
        const n = nodes.find((node) => node.id == id)

        // If the countId is null all nodes with null count ids would be returned
        const impacts = nodes.filter((node) => node.prioritizationModel?.countId == n.prioritizationModel?.countId)
            .map((node) => node.id)

        // To prevent all nulls getting selected
        return n.prioritizationModel?.countId ? impacts : [id]
    }

    const getRelatedGroupNodeIds = (id) => {
        const n = nodes.find((node) => node.id == id)

        // If the countId is null all nodes with null count ids would be returned
        const impacts = nodes.filter((node) => node.prioritizationModel?.groupId == n.prioritizationModel?.groupId)
            .map((node) => node.id)

        // To prevent all nulls getting selected
        return n.prioritizationModel?.groupId ? impacts : [id]
    }

    const nodesWithData = nodes.map((node) => {
        if (node.type == 'staticImpact') {
            return {
                ...node,
                data: {
                    ...node.data,
                    isSelected: selected.includes(node.id),
                    selected: selected,
                    setSelected: setSelected,
                    getRelatedCountNodeIds,
                    getRelatedGroupNodeIds,
                    count: node.countGroup,
                    group: node.group,
                    countUpdated: updatedCtName[node.prioritizationModel?.countId],
                    groupUpdated: updatedGroupName[node.prioritizationModel?.groupId],
                    countId: node.prioritizationModel?.countId,
                    groupId: node.prioritizationModel?.groupId,
                    isAddMode: isAddMode,
                    isDeleteMode: isDeleteMode,
                    showCount: showCount,
                    showGroup: showGroup,
                    selectedCountId: selectedCountId,
                    selectedGroupId: selectedGroupId,
                    prioritized: node.prioritizationModel?.criteria_score !== null,
                    rank: node.prioritizationModel?.individualRank,
                    colorNumber: node.colorNumber
                },
                draggable: false
            };
        } else {
            return {
                ...node,
                data: {
                    ...node.data,
                    colorNumber: node.colorNumber
                },
                draggable: false
            };
        }
    });

    let selectedNotCounted = true
    selected.forEach((nid) => {
        const node = nodes.find((node) => node?.id == nid)
        if (node?.prioritizationModel?.countId) {
            selectedNotCounted = false
        }
    })

    let selectedNotGrouped = true
    selected.forEach((nid) => {
        const node = nodes.find((node) => node?.id == nid)
        if (node?.prioritizationModel?.groupId) {
            selectedNotGrouped = false
        }
    })

    const canPrioritize = () => {
        let canP = true
        if(!nodes.length){
            return false
        }
        nodes.filter((node) => node.type !== 'diagramHeader').forEach((node) => {
            if (!node.prioritizationModel?.criteria_score || !node.prioritizationModel.groupId) {
                // console.log('Cant: ', node)
                canP = false
                return
            }
        })
        return canP
    }

    useEffect(() => {
        if (canPrioritize()) {
            setShowHints(false)
        }
    }, [nodes])

    return (
        <>
         <ReactFlowProvider>
            {
                loading &&
                <div className=' absolute z-[10000] top-5 right-5 items-center justify-center'>
                    <Loader animationName={'loader'} height={100} width={100} />
                </div>
            }
           
            {
                canPrioritize() && (
                    <div onClick={prioritize} className='py-3 px-10 font-semibold z-50 border-2 border-teal-600 text-teal-500  hover:text-gray-200 hover:bg-teal-900 absolute rounded-lg text-white text-md right-5 top-10 cursor-pointer'>
                        Prioritize
                    </div>
                )
            }
            {
                isPrioritized && (
                    <div onClick={() => { setShowTable(true)}} className='py-2 px-5 font-semibold z-50 text-gray-200 bg-teal-800 hover:bg-teal-900 absolute rounded text-white text-md right-5 top-28 cursor-pointer'>
                        Table View
                    </div>
                )
            }
            {
                showTable && Object.keys(tableData).length && (
                    <div className='absolute z-[10001] flex w-full h-[100vh] p-28 bg-black/80'>
                        <Table onCloseClick={()=>setShowTable(false)} tableHeaders={tableData.tableHeaders} tableBody={tableData.tableBody} />
                    </div>
                )
            }
            <div className={`${showCount || showGroup ? 'left-0 w-[300px]' : 'left-[-200px] w-[200px]'} z-50 overflow-y-scroll text-white duration-300 h-full flex flex-col items-center p-2 pl-14 pr-14 bg-gray-900/40 rounded-lg absolute top-0`}>
                {
                    showCount &&
                    (
                        <>
                            <div onClick={isAddMode ? addToCount : isDeleteMode ? removeFromCount : () => openInputModal('Description (could be name)', 'Enter a name or descriptive', countImpacts)} className={`${selected.length > 1 && (isAddMode || selectedNotCounted || isDeleteMode) ? 'flex' : 'hidden'} text-sm w-full text-gray-400 justify-center py-3 border-2 border-gray-600 mt-5 rounded-2xl cursor-pointer hover:font-semibold hover:border-4`}>
                                {isAddMode ? 'Add' : isDeleteMode ? 'Update' : selectedNotCounted ? 'Create count group' : ''}
                            </div>
                            <div className='text-sm text-orange-400 p-3 border-b-2 border-orange-600 mb-5'>
                                Repeated Impacts
                            </div>
                            <div className='flex flex-col w-full'>
                                {
                                    countIds.map((countId, index) => (
                                        <div onClick={() => {
                                            setIsDeleteMode(false)
                                            setIsAddMode(false)
                                            if (selectedCountId == countId) {
                                                setSelectedCountId('')
                                                setSelected([])
                                            } else {
                                                setSelected(
                                                    nodes.filter((node) => {
                                                        return node.prioritizationModel?.countId == countId || node._id == countId
                                                    }).map((node) => node.id)
                                                )
                                                setSelectedCountId(countId)
                                            }
                                        }} className={`${selectedCountId != countId ? 'text-gray-400 bg-gray-800 rounded' : 'text-white bg-orange-400/70'} flex justify-between items-center cursor-pointer p-3 py-2 text-sm w-full mt-1`}>
                                            <span className='truncate'>{updatedCtName[countId] || counts[index].countDescription} </span> {selectedCountId === countId && <span onClick={()=>openInputModal('Edit Count Name', updatedCtName[countId] || counts[index].countDescription, editCountName)} className='ml-2 text-slate-600 px-2 py-1 bg-white rounded-lg'><FontAwesomeIcon icon={faFileEdit} size='sm'/></span>}  {selectedCountId === countId  && <span onClick={() => openModal('Delete Count?', `Are you sure you want to delete count "${ updatedCtName[countId] || counts[index].countDescription}"`, deleteCount(countId))} className='ml-2 text-red-500 px-2 py-1 bg-white rounded-lg'><FontAwesomeIcon icon={faTrash} size='sm'/></span>}
                                        </div>
                                    ))

                                }
                            </div>
                        </>
                    )
                }
                {
                    showGroup &&
                    (
                        <>
                            <div onClick={isAddMode ? addToGroup : isDeleteMode ? removeFromGroup : () => openInputModal('Group name', 'Enter a name for the selected group', groupImpacts)} className={`${selected.length && (isAddMode || selectedNotGrouped || isDeleteMode) ? 'flex' : 'hidden'} text-sm w-full text-gray-400 justify-center py-3 border-2 border-gray-600 mt-5 rounded-2xl cursor-pointer hover:font-semibold hover:border-4`}>
                                {isAddMode ? 'Add' : isDeleteMode ? 'Update' : selectedNotGrouped ? 'create group' : ''}
                            </div>
                            <div className='text-sm text-teal-400 p-3 border-b-2 border-teal-600 mb-5'>
                                Impact Groups
                            </div>
                            {
                                groupIds.map((groupId, index) => (
                                    <div onClick={() => {
                                        setIsDeleteMode(false)
                                        setIsAddMode(false)
                                        if (selectedGroupId == groupId) {
                                            setSelectedGroupId('')
                                            setSelected([])
                                        } else {
                                            setSelected(
                                                nodes.filter((node) => {
                                                    return node.prioritizationModel?.groupId == groupId  || node._id == groupId
                                                }).map((node) => node.id)
                                            )
                                            setSelectedGroupId(groupId)
                                        }
                                    }} className={`${selectedGroupId != groupId ? 'text-gray-400 bg-gray-800 rounded' : 'text-white bg-teal-400/70'} flex justify-between items-center cursor-pointer p-3 py-2 text-sm w-full mt-1`}>
                                        <span className='truncate'>{updatedGroupName[groupId] || groups[index].groupName}</span>{selectedGroupId === groupId && <span onClick={() => openInputModal('Edit group name', updatedGroupName[groupId] || groups[index].groupName, editGroupName)} className='ml-2 text-slate-600 px-2 py-1 bg-white rounded-lg'><FontAwesomeIcon icon={faFileEdit} size='sm'/></span>} {selectedGroupId === groupId && <span onClick={() => openModal('Delete Group?', `Are you sure you want to delete group "${updatedGroupName[groupId] || groups[index].groupName}"`, deleteGroup(groupId))} className='ml-2 text-red-500 px-2 py-1 bg-white rounded-lg'><FontAwesomeIcon icon={faTrash} /></span>}
                                    </div>
                                ))
                            }
                        </>
                    )
                }
            </div>
            <div className={`${showHints ? 'top-0' : 'top-[-700px]'} w-[400px] z-50 overflow-y-scroll text-white duration-500 flex flex-col rounded-lg items-center px-5 py-5 bg-gray-900/40 rounded-lg absolute right-1`}>
                <div className='w-full flex mb-5'>
                    <div onClick={() => setShowHints(false)} className='w-6 h-6 cursor-pointer flex justify-center items-center border-2 border-gray-200 text-gray-200 rounded-lg'>
                        <FontAwesomeIcon icon={faClose} />
                    </div>
                </div>
                {
                    <>
                        <div className='text-md'>
                            {hintNumber == 0 &&
                                <>
                                    <div>
                                        Do you see any repeated impacts?
                                    </div>
                                    <div className='flex justify-around w-full mt-3'>
                                        <div onClick={() => { setHintNumber(1); setShowCount(true); setShowGroup(false) }} className='cursor-pointer hover:text-teal-500'>Yes</div>
                                        <div onClick={() => { setHintNumber(2); setShowCount(false); setShowGroup(true) }} className='cursor-pointer hover:text-red-500'>No</div>
                                    </div>
                                </>
                            }
                            {hintNumber == 1 &&
                                <div>
                                    Select them.
                                </div>
                            }

                            {hintNumber == 1 && !selectedNotCounted &&
                                <>
                                    <div className='text-red-500/90 mt-3'>
                                        A selected impact has already been identified as a repeated impact. Please deselect by clicking again
                                    </div>
                                </>
                            }

                            {hintNumber == 1 && selected.length > 1 && selectedNotCounted &&
                                <>
                                    <div className='mt-3 text-gray-400'>
                                        After selecting multiple impacts you should see a "create count group" button appear on top of the menu on the far left.
                                    </div>
                                    <div className='mt-3 text-gray-400'>
                                        Click that to let me know they are the same.
                                    </div>
                                </>
                            }
                            {hintNumber == 2 && !(selected.length > 0 && !selectedNotGrouped) &&
                                <>
                                    <div>
                                        Categorize all impacts into groups. Single member groups are permitted
                                    </div>
                                    <div className='flex justify-around w-full mt-3 text-gray-400'>
                                        1. Select impacts that should be categorized / grouped together
                                    </div>
                                </>
                            }
                            {hintNumber == 2 && selected.length > 0 && selectedNotGrouped &&
                                <>
                                    <div className='flex justify-around w-full mt-3 text-gray-400'>
                                        2. Click on the group button on top of the menu on the far left, after completing your selection.
                                    </div>
                                </>
                            }
                            {hintNumber == 2 && selected.length > 0 && !selectedNotGrouped &&
                                <>
                                    <div className='flex justify-around text-red-500/90 w-full mt-3'>
                                        A selected impact has already been grouped. Please deselect by clicking again
                                    </div>
                                </>
                            }
                            {hintNumber == 3 &&
                                <>
                                    <div className='flex justify-around w-full mt-3'>
                                        Make sure all impacts are grouped to unlock prioritization. Ungrouped impacts have a text indication
                                    </div>
                                </>
                            }
                        </div>
                        {/* <div className='text-md'>
                            <div>
                                Did you miss any repeated impacts for a set and want to add more?
                            </div>
                            <div className='mt-5'>
                                1. Select the item from the repeated impacts list above
                            </div>
                            <div>
                                2. Click the [ + ] button on the right side of the menu to enter add mode.
                            </div>
                            <div>
                                3. Select the impacts you missed. (Impact belonging to another repeated impacts set cannot be selected)
                            </div>
                            <div>
                                5. After selecting, click the "Add" button to update the selected repeated impacts set
                            </div>
                        </div> */}
                    </>
                }
            </div>
            <div className={`${isAddMode || isDeleteMode ? 'top-0' : 'top-[-200px]'} z-40 duration-300 flex flex-col px-5 py-3 border border-gray-500 border-4 bg-gray-100 rounded absolute right-[100px]`}>
                <div className='flex text-sm'>
                    {infoText}
                </div>
            </div>
            <div className={`${countIds.includes(selectedCountId) || groupIds.includes(selectedGroupId) ? 'left-[300px]' : 'left-[-200px]'} z-40 duration-300 flex flex-col p-2 bg-gray-900/40 rounded-r-lg absolute top-1/3`}>
                <div className='flex flex-col py-2'>
                    <button onClick={() => { setIsAddMode(!isAddMode); setShowHints(false); setIsDeleteMode(false); setInfoText(`Add Mode ON: Select impacts to add to selected ${selectedCountId ? 'count' : ''} group and then hit add`) }} data-tooltip-content={`Add to selected ${selectedCountId ? 'count' : 'group'}`} data-tooltip-id='add' className={`p-2 ${isAddMode ? 'bg-gray-200 text-black ' : 'text-white bg-gray-800'} hover:text-white hover:bg-gray-600 transition-all ease-linear duration-200`}>
                        <FontAwesomeIcon icon={faPlus} size='1x' />
                        <Tooltip place='right' id='add' />
                    </button>
                    <button onClick={() => { setIsDeleteMode(!isDeleteMode); setShowHints(false); setIsAddMode(false); setInfoText(`Delete Mode ON: Select impacts to remove from selected ${selectedCountId ? 'count' : ''} group and then hit update`) }} data-tooltip-content={`Remove from selected ${selectedCountId ? 'count' : 'group'}`} data-tooltip-id='remove' className={`p-2 ${isDeleteMode ? 'bg-gray-200 text-black ' : 'text-white bg-gray-800'} hover:text-white hover:bg-gray-600 transition-all ease-linear duration-200`}>
                        <FontAwesomeIcon icon={faMinus} size='1x' />
                    </button>
                    <Tooltip place='right' id='remove' />
                </div>
            </div>
            <div className={`${sidebarOpen ? 'left-0' : 'left-[200px]'} z-50 duration-300 flex flex-col p-2 bg-gray-900/40 rounded-r-lg absolute top-1/3`}>
                <div className='flex flex-col py-2'>
                    {
                        (showGroup || showCount) &&
                        <button onClick={() => { setShowCount(false); setShowGroup(false); setShowHints(false); setSelected([]); setIsAddMode(false); setIsDeleteMode(false); setSelectedCountId(''); setSelectedGroupId('') }} data-tooltip-content={'Close Menu'} data-tooltip-id='close' className='p-2 text-white bg-gray-800 rounded-3xl hover:rounded-xl hover:bg-gray-600 transition-all ease-linear duration-200'>
                            <FontAwesomeIcon icon={faClose} size='lg' />
                        </button>
                    }
                    <button onClick={() => { setShowCount(true); setHintNumber(0); setShowHints(true); setShowGroup(false); setSelected([]); setIsAddMode(false); setIsDeleteMode(false); setSelectedCountId(''); setSelectedGroupId('') }} data-tooltip-content={'Count'} data-tooltip-id='count' className='p-2 text-orange-400 bg-gray-800 hover:text-white rounded-3xl hover:rounded-xl hover:bg-orange-600 mt-2 transition-all ease-linear duration-200'>
                        <FontAwesomeIcon icon={faListNumeric} size='lg' />
                    </button>
                    <Tooltip place='right' id='count' />
                    <button onClick={() => { setShowGroup(true); setHintNumber(2); setShowHints(true); setShowCount(false); setSelected([]); setIsAddMode(false); setIsDeleteMode(false); setSelectedCountId(''); setSelectedGroupId('') }} data-tooltip-content={'Group'} data-tooltip-id='group' className='p-2 text-teal-400 bg-gray-800 rounded-3xl hover:text-white hover:rounded-xl hover:bg-teal-600 mt-2 transition-all ease-linear duration-200'>
                        <FontAwesomeIcon icon={faObjectGroup} size='lg' />
                    </button>
                    <Tooltip place='right' id='group' />

                    
                    <TakeSnapshot
                        data-tooltip-content={'Download'} 
                        data-tooltip-id='download' 
                        diagramName={`${state.project.name} impacts`} 
                        className= 'p-2 text-fuchsia-400 bg-gray-800 hover:text-white hover:rounded-xl hover:bg-fuchsia-600 mt-2 transition-all ease-linear duration-200'/>
                    <Tooltip place='right' id='download' />
                    
                    <>
                    <div onClick={() => {
                        openModal("Exit?",
                        `Make sure everything is saved before you exit. Are you sure you want to exit? `,
                        () => { navigate(-1) }
                        )}} data-tooltip-content={'Exit'} data-tooltip-id='exit' className='p-2 text-red-500 bg-gray-800 rounded-3xl hover:text-white hover:rounded-xl hover:bg-red-600 mt-2 transition-all ease-linear duration-200'>
                        <FontAwesomeIcon icon={faSignOutAlt} />
                    </div>
                    </>
                    <Tooltip place='right' id='exit' />
                </div>
            </div>
           
            <ReactFlow
                nodes={nodesWithData}
                edges={edges}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                onInit={onInit}
                fitView
                attributionPosition="top-right"
                nodeTypes={nodeTypes}
            >
                <MiniMap style={minimapStyle} zoomable pannable />
                <Controls />
                <Background color="#aaa" gap={16} />
            </ReactFlow>
            </ReactFlowProvider>
        </>
    );
};

export default PrioritizationUI;